module.exports = __webpack_public_path__ + "img/icon.9053c8d0.png";